<div class="card card-inverse {{bgClass}}">
    <div class="card-header">
        <div class="row">
            <div class="col col-xs-3">
                <em class="fa {{icon}} fa-5x"></em>
            </div>
            <div class="col col-xs-9 text-right">
                <div class="d-block huge" style="font-size: 17px;text-align: right;">{{count}}</div>
                <div class="d-block" style="font-size: 17px;text-align: right;">{{label}}</div>
                <div style="font-size: 13px;color: blue;text-align: right;"> {{info}}</div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <span class="float-left" style="font-size: 17px">View Details</span>
        <a [routerLink]="[data]" class="float-right card-inverse">
            <span class="float-end"><em class="fa fa-arrow-circle-right"></em></span>
        </a>

    </div>
</div>